//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/ugmath.js";
let d=[[],[[["bendRcp"],"SetRCP",{},1,0],[["angle"],"UpdateAngle",{},1,0],[["moveAttached"],"SetMoveAttachedFlag",{},1,0],[[],"SwapAnchorSegment",{},0,0],[["anchorSegDir","rcpPos","planeNormal"],"GetSelectedBendData",{R_:{angle:''}},0,0],[[],"CommitCurrentEdit",{},0,0]],[]];
SPLM.Routing.EditBendAngleBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.EditBendAngleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;